import { render, staticRenderFns } from "./knowledgeAction.vue?vue&type=template&id=7e728212&scoped=true"
import script from "./knowledgeAction.vue?vue&type=script&lang=js"
export * from "./knowledgeAction.vue?vue&type=script&lang=js"
import style0 from "./knowledgeAction.vue?vue&type=style&index=0&id=7e728212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e728212",
  null
  
)

export default component.exports